<template>
  <div class="active">
    <div class="activetitle">中国年青马大赛《凌志范儿》报名入口</div>
    <div class="mb-100">
      <van-cell-group>
        <div class="box">
          <span class="titlenum">01</span>
          <span class="titlename">联系人姓名</span>
        </div>
        <van-field v-model="params.name" placeholder="填写姓名" />
      </van-cell-group>
      <van-cell-group>
        <div class="box">
          <span class="titlenum">02</span>
          <span class="titlename">联系电话</span>
        </div>
        <van-field v-model="params.mobile" placeholder="填写手机号" maxlength='11' type='tel' />
      </van-cell-group>
      <van-cell-group>
        <div class="box">
          <span class="titlenum">03</span>
          <span class="titlename">成人数</span>
        </div>
        <van-field v-model="params.man_num" type='number' placeholder="填写数字"  />
      </van-cell-group>
      <van-cell-group>
        <div class="box">
          <span class="titlenum">04</span>
          <span class="titlename">是否有儿童</span>
        </div>
        <van-radio-group v-model="params.is_child">
          <van-radio name="1" checked-color="#605C6B">有儿童</van-radio>
          <van-radio name="0" checked-color="#605C6B">没有儿童</van-radio>
        </van-radio-group>
      </van-cell-group>
      <van-cell-group v-if="params.is_child==''||params.is_child==0">
        <div class="box">
          <span class="titlenum">05</span>
          <span class="titlename">前往方式</span>
        </div>
        <van-radio-group v-model="params.vehicle_type">
          <van-radio name="1" checked-color="#605C6B">自驾</van-radio>
          <van-radio name="0" checked-color="#605C6B">其他</van-radio>
        </van-radio-group>
      </van-cell-group>
      <!-- <van-cell-group v-if="params.is_child==1">
        <div class="box">
          <span class="titlenum">05</span>
          <span class="titlename">儿童年龄</span>
        </div>
        <van-radio-group v-model="params.child_age">
          <van-radio name="0" checked-color="#605C6B">6-8岁</van-radio>
          <van-radio name="1" checked-color="#605C6B">9-12岁</van-radio>
          <van-radio name="2" checked-color="#605C6B">13岁以上</van-radio>
        </van-radio-group>
      </van-cell-group> -->
      <van-cell-group v-if="params.is_child==1">
        <div class="box">
          <span class="titlenum">05</span>
          <span class="titlename">儿童数</span>
        </div>
        <van-field v-model="params.child_num" type='number' placeholder="填写数字" />
      </van-cell-group>
      <van-cell-group v-if="params.is_child==1">
        <div class="box">
          <span class="titlenum">06</span>
          <span class="titlename">前往方式</span>
        </div>
        <van-radio-group v-model="params.vehicle_type">
          <van-radio name="1" checked-color="#605C6B">自驾</van-radio>
          <van-radio name="0" checked-color="#605C6B">其他</van-radio>
        </van-radio-group>
      </van-cell-group>
      <div v-if="params.is_child==''||params.is_child==0">
        <van-cell-group v-if="params.vehicle_type==1">
          <div class="box">
            <span class="titlenum">06</span>
            <span class="titlename">车牌号</span>
          </div>
          <van-field v-model="params.car_number" placeholder="例：京A 12345" />
        </van-cell-group>
        <van-cell-group v-if="params.vehicle_type==1">
          <div class="box">
            <span class="titlenum">07</span>
            <span class="titlename">车型信息</span>
          </div>
          <van-field readonly clickable v-model="params.car_model_name" placeholder="选择车型信息" @click="showPicker = true" />
        </van-cell-group>
      </div>
      <div v-else>
        <van-cell-group v-if="params.vehicle_type==1">
          <div class="box">
            <span class="titlenum">07</span>
            <span class="titlename">车牌号</span>
          </div>
          <van-field v-model="params.car_number" placeholder="例：京A 12345" />
        </van-cell-group>
        <van-cell-group v-if="params.vehicle_type==1">
          <div class="box">
            <span class="titlenum">08</span>
            <span class="titlename">车型信息</span>
          </div>
          <van-field readonly clickable v-model="params.car_model_name" placeholder="选择车型信息" @click="showPicker = true" />
          <!-- <van-dropdown-menu>
            <van-dropdown-item v-model="values" :options="options" @open='openDropdown' />
          </van-dropdown-menu> -->
        </van-cell-group>
      </div>
      
    </div>
    <div class="btn-box">
      <van-button color="#605C6B" size="large" @click="saveInfo" v-if="source==6||source==8||source==9">确认提交</van-button>
      <van-button color="#1F2A74" style="border-radius: 6px;" size="large" @click="saveInfo" v-if="source==5">确认提交</van-button>
      <van-button color="#AA0000" size="large" @click="saveInfo" v-if="source==12">确认提交</van-button>
      <van-button color="#FFBB00" style="border-radius: 6px;" size="large" @click="saveInfo" v-if="source==1||source==3||source==4||source==7||source==11">确认提交</van-button>
    </div>
    <van-popup v-model="showPicker" position="bottom">
      <van-picker
      title=""
      show-toolbar
      :columns="columns"
      @confirm="onConfirm"
      @cancel="onCancel"
      @change="onChange"
      />
    </van-popup>
  </div>

</template>
<script>
  import active from '../../../api/lexus/active';
  import list from '../../../api/member/mycars';
  import common from '../../../api/common';
  import {Field,Button,RadioGroup,Radio,Cell, CellGroup,Picker,Popup } from 'vant';
  export default {
    data () {
      return {
        params:{
          hid:13,
          name:'',
          man_num:'',
          is_child:'',
          child_num:'',
          vehicle_type:'',
          car_number:'',
          car_model_id:'',
          car_model_name:'',
        },
        showPicker:false,
        columns: [],
        again:0,
        source:1
      }
    },
    created () {
      this.$store.commit('param/show', false)
      this.$appService.isShowReturn({state: true})
      this.$appService.isTabbar({state: true})
      var apppar={
        title:this.$route.meta.title
      }
      this.$appService.changeTitle(apppar)
      this.getCars()
      if(this.$route.query.token){
        this.source = this.$route.query.source
        this.token = this.$route.query.token
        this.user_id = this.$route.query.userid
        this.$store.dispatch('param/setToken', this.$route.query.token)
        this.getActivity(this.$route.query.userid)
      }else if(this.$route.params.token){
        this.source = this.$route.params.source
        this.token = this.$route.params.token
        this.$store.dispatch('param/setToken', this.$route.params.token)
        this.user_id = this.$route.params.user_id
        this.again=this.$route.params.again
        this.getActivity(this.$route.params.user_id)
      }
    },

    methods: {
      getCars(){
        var params={
          brand_id:1,
          region:1
        }
        list.getCars(params).then(res => {
          if(res.data.state == 1) {
            var lists=res.data.data
            var columns =[]
            for (let i in lists) {
              var params={
                text:lists[i].title,
                id:lists[i].id
              }
              columns.push(params); 
            }
            this.columns=columns

          }
        })
      },
      getActivity(id){
        var params={
          user_id:parseInt([id]),
        }
        common.getActivity(params,13).then(res => {
          if(res.data.state==1){
            this.activeinfo=res.data.data
            if(res.data.data.is_enroll==1&&this.again==0){
              // this.$router.push({name:'LexusActiveok',params:{source:this.source,token:this.token,user_id:this.user_id}});
              wx.miniProgram.reLaunch({url: '/pages/webpage/webpage?scene=https://m.motortime.com/lexus/active/activeok'})
            }
            var params={
              event_code: '活动邀请',
              event_id: res.data.data.id,
              title: res.data.data.title,
              value: '',
              path: '/Lexus/Active/Active.vue',
              user_id: this.user_id ? this.user_id : 0,
              source: this.source
            }
            common.BurialPoint(params).then(res => {
              if(res.data.state==1){

              }
            })
          }
        })
      },
      
      saveInfo(){
        if(this.params.name==''){
          this.$toast('请填写联系人姓名');
          return false
        }else if(this.params.mobile==''){
          this.$toast('请填写联系电话');
          return false
        }else if(!(/^1[3456789]\d{9}$/.test(this.params.mobile))){
          this.$toast('请填写正确的手机号');
          return false
        }else if(this.params.man_num==''){
          this.$toast('请填写成人数');
          return false
        }else if(this.params.is_child==''){
          this.$toast('请选择是否有儿童');
          return false
        }else if(this.params.is_child==1){
          if(this.params.child_num==''){
            this.$toast('请填写儿童数');
            return false
          }
        }
         if(this.params.vehicle_type==''){
          this.$toast('请选择前往方式');
          return false
        }
        if(this.params.vehicle_type==1){
          if(this.params.car_number==''){
            this.$toast('请填写车牌号');
            return false
          }else if(this.params.car_model_id==''){
            this.$toast('请选择车型信息');
            return false
          }
        }
        common.activeApply(this.params).then(res => {
          if(res.data.state==1){
             // this.$router.push({name:'LexusActiveok',params:{source:this.source,token:this.token,user_id:this.user_id}});
             wx.miniProgram.reLaunch({url: '/pages/webview/webview?scene=https://m.motortime.com/lexus/active/activeok'})
             var params={
              hid:13,
              name:'',
              man_num:'',
              is_child:'',
              child_num:'',
              vehicle_type:'',
              car_number:'',
              car_model_id:'',
              car_model_name:'',
            }
            this.params=params
          }
        })
      },
      onConfirm(value, index) {
        this.showPicker=false
        this.params.car_model_name=value.text
        this.params.car_model_id=value.id
        // Toast(`当前值：${value}, 当前索引：${index}`);
      },
      onChange(picker, value, index) {
        // Toast(`当前值：${value}, 当前索引：${index}`);
      },
      onCancel() {
        // Toast('取消');
      },
    },
    components: {
      [RadioGroup.name]: RadioGroup,
      [Radio.name]: Radio,
      [Field.name]:Field,
      [Button.name]:Button,
      [Cell.name]: Cell,
      [CellGroup.name]:CellGroup,
      [Picker.name]:Picker,
      [Popup.name]:Popup
    }
  }
</script>
<style lang="scss">
.active{
  .activetitle{
    font-size: 16px;
    text-align: center;
    margin: 30px 0;
    font-weight: bold;
  }
  .van-cell-group{
    padding: 5px 0;
  }
  .box{
    margin-left: 15px;
    .titlenum{
      font-size: 20px;
      font-weight: bold;
      color: #3A3A3A;
    }
    .titlename{
      font-size: 14px;
      color: #3A3A3A;
      margin-left: 5px;
    }
  }
  .van-radio-group{
    display: flex;
    padding: 10px 15px;
  }
  .van-radio{
    margin-right: 40px;
    .van-radio__label{
      font-size: 14px;
    }
  }
  .btn-box{
    width: 100%;
    bottom: 20px;
    position: fixed;
    text-align: center;
    .van-button--large{
      width: 90%;
    }
    // @button-border-radius{
    //   border-radius:6px;
    // }
  }

  .mb-100{
    margin-bottom: 100px;
  }
  .mb-240{
    margin-bottom: 240px;
  }
}
</style>
